<section class="vc_row pt-130 pb-100" data-section-luminance="light" *ngIf="pageData['home_articles_active'] == 1">
    <div class="container">
        <div class="row">
            <div class="lqd-column col-md-6 col-md-offset-3 text-center mb-10">
                <h2 class="mt-2 mb-2 font-weight-normal lh-1"><strong [innerHTML]="pageData['home_articles_title']">Interesting articles</strong></h2>
                <p class="h3 font-weight-normal mb-40 mt-4"><i [innerHTML]="pageData['home_articles_subtitle']">in news & events.</i></p>
            </div>
            <div class="lqd-column col-md-12">
                <div class="liquid-blog-posts">

                    <div class="col-md-12" *ngIf="listFailed">
                      <raksme-error [showRetry]="true" (retry)="retryList()"></raksme-error>
                    </div>
                    <div class="col-md-12" *ngIf="!listFailed && listLoaded && !allItems?.length">
                      <raksme-empty></raksme-empty>
                    </div>
                    <div class="row row-eq" *ngIf="newsData.status == 1">

                        <div class="lqd-column col-md-4 branding masonry-item mb-60" *ngFor="let news of allItems">
                          <raksme-news-card [news]="news" [langUrl]="langUrl" [readMoreLabel]="generalLabels['article_detail']"></raksme-news-card>
                        </div>

                        
                        
                    </div>

                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center mt-3">
                <a routerLink="/media-center/{{pageData['home_articles_more_btn_pageUrl']}}{{langUrl}}" class="btn btn-solid text-uppercase semi-round border-thin font-weight-bold" [target]="pageData['home_articles_more_btn_new_window'] == 1 ? '_blank':'_self'">
                    <span class="btn-txt" [innerHTML]="pageData['home_articles_more_btn_label']">See all articles</span>
                </a>
            </div>
        </div>
    </div>
    <div class="col-md-12" style="position: absolute;z-index: -1;bottom: 0;">
        <!-- <img
            src="../../../../../assets/img/pattern-10.png" style="max-width: 400px;opacity: 0.05;float: right;"> -->
        </div>
</section>